// extracted by mini-css-extract-plugin
export default {"container":"KDFE_","disabledIcon":"cxMz2","stakeContainer":"msGDE","stake":"fqvP5"};